interface DetailMeta {
  icon: string;
  text: string;
}

interface DetailBannerProps {
  cover: string;
  badge: string;
  title: string;
  metas: DetailMeta[];
}

export default function DetailBanner({ cover, badge, title, metas }: DetailBannerProps) {
  return (
    <div className="relative w-full overflow-hidden">
      <img
        src={cover}
        alt={title}
        title={`${title} - 我的朋友他的妻子`}
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/95 via-foreground-950/75 to-foreground-950/45"></div>
      <div className="relative z-10 mx-auto flex w-full max-w-content flex-col gap-4 px-4 pb-8 pt-14 md:px-6 md:pb-12 md:pt-20">
        <span className="w-fit rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-foreground-950">
          {badge}
        </span>
        <h1 className="max-w-4xl font-heading text-2xl font-black leading-tight text-background-50 md:text-4xl">
          {title}
        </h1>
        <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-background-200 md:text-sm">
          {metas.map((meta) => (
            <span key={meta.text} className="flex items-center gap-1.5">
              <i className={meta.icon}></i>
              {meta.text}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}